<script setup>
import { useI18n } from 'vue-i18n';
import { useSupportTicketFormatters } from '../composables/useSupportTicketFormatters';

defineProps({
  assistanceReport: { type: Object, default: null },
  isLoadingAssistanceReport: { type: Boolean, default: false },
});

const { t } = useI18n();
const { formatAssistanceMoney, formatAssistanceDecimal } =
  useSupportTicketFormatters();
</script>

<template>
  <div
    class="grid gap-3 rounded-lais border border-lais-border-soft bg-lais-bg px-3 py-3"
  >
    <div class="flex flex-wrap items-center justify-between gap-3">
      <p class="text-[12px] font-semibold text-lais-text">
        {{ t('SUPPORT_TICKETS.ASSISTANCE.REPORT.TITLE') }}
      </p>
      <span class="text-[11px] text-lais-text-muted">
        {{
          isLoadingAssistanceReport
            ? t('SUPPORT_TICKETS.ASSISTANCE.REPORT.LOADING')
            : t('SUPPORT_TICKETS.ASSISTANCE.REPORT.WINDOW')
        }}
      </span>
    </div>
    <div class="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <div>
        <p class="text-[11px] font-semibold text-lais-text-muted">
          {{ t('SUPPORT_TICKETS.ASSISTANCE.REPORT.TOTAL') }}
        </p>
        <p class="mt-1 text-[16px] font-semibold text-lais-text">
          {{ assistanceReport?.metrics?.total_tickets || 0 }}
        </p>
      </div>
      <div>
        <p class="text-[11px] font-semibold text-lais-text-muted">
          {{ t('SUPPORT_TICKETS.ASSISTANCE.REPORT.SATISFACTION') }}
        </p>
        <p class="mt-1 text-[16px] font-semibold text-lais-text">
          {{
            formatAssistanceDecimal(
              assistanceReport?.metrics?.average_satisfaction_score
            )
          }}
        </p>
      </div>
      <div>
        <p class="text-[11px] font-semibold text-lais-text-muted">
          {{ t('SUPPORT_TICKETS.ASSISTANCE.REPORT.RECURRENCE') }}
        </p>
        <p class="mt-1 text-[16px] font-semibold text-lais-text">
          {{ assistanceReport?.metrics?.recurrence_tickets || 0 }}
        </p>
      </div>
      <div>
        <p class="text-[11px] font-semibold text-lais-text-muted">
          {{ t('SUPPORT_TICKETS.ASSISTANCE.REPORT.RESOLUTION') }}
        </p>
        <p class="mt-1 text-[16px] font-semibold text-lais-text">
          {{
            formatAssistanceDecimal(
              assistanceReport?.metrics?.average_resolution_hours
            )
          }}
        </p>
      </div>
    </div>
    <p class="text-[12px] text-lais-text-muted">
      {{
        assistanceReport?.costs?.restricted
          ? t('SUPPORT_TICKETS.ASSISTANCE.REPORT.COST_RESTRICTED')
          : t('SUPPORT_TICKETS.ASSISTANCE.REPORT.COST_TOTAL', {
              value: formatAssistanceMoney(
                assistanceReport?.costs?.total_cost_amount,
                assistanceReport?.costs?.currency
              ),
            })
      }}
    </p>
  </div>
</template>
